/**
 * Frontend-side copy of the scope profile metadata for display purposes.
 * Keep in sync with packages/backend/src/plugins/api-tokens/scopes.ts.
 */
export interface ScopeProfileUI {
  id: string;
  label: string;
  description: string;
}

export const SCOPE_PROFILES_UI: ScopeProfileUI[] = [
  {
    id: 'catalog:read',
    label: 'Catalog (read-only)',
    description: 'Read catalog entities, locations, and relations.',
  },
  {
    id: 'catalog:readwrite',
    label: 'Catalog (read + write)',
    description: 'Full catalog access — read, create, update, and delete.',
  },
  {
    id: 'scaffolder',
    label: 'Scaffolder',
    description: 'List and execute scaffolder templates.',
  },
  {
    id: 'techdocs:read',
    label: 'TechDocs (read-only)',
    description: 'Read TechDocs documentation pages.',
  },
  {
    id: 'search',
    label: 'Search',
    description: 'Query the Backstage search index.',
  },
];
